import React from "react";
import PropTypes from "prop-types";

const Separator = ({ space }) => {
  return <div style={{ height: `var(--spacing-${space})` }}></div>;
};

Separator.propTypes = {
  space: PropTypes.string,
};

Separator.defaultProps = {
  space: "l",
};

export default Separator;
